import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@material-ui/core";

export interface MessageDialogProps {
  isDialogOpened: boolean;
  title?: string;
  message?: string;
  actions?: { caption: string; onClick: () => void }[];
}

type Props = MessageDialogProps;

class MessageDialog extends React.Component<Props> {
  render() {
    return (
      <Dialog open={this.props.isDialogOpened}>
        <DialogTitle>{this.props.title || ""}</DialogTitle>
        <DialogContent>{this.props.message || ""}</DialogContent>
        <DialogActions>
          {this.props.actions && this.props.actions.map(a => (
            <Button onClick={a.onClick}>{a.caption}</Button>
          ))}
        </DialogActions>
      </Dialog>
    );
  }
}

export default MessageDialog;



// WEBPACK FOOTER //
// ./src/components/MessageDialog.tsx